
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
:host {
  position: relative;
  height: 100%;
  place-self: stretch;
  overflow: hidden;
  border-radius: 0.5rem;
}

  :host a {
  color: var(--outline-black);
}

  :host a {
  -webkit-text-decoration-line: none;
          text-decoration-line: none;
}

  :host a:hover {
  color: var(--outline-white);
}

.fit{
  display:inline-block;
  white-space:nowrap;
}

.card {
  margin: auto;
  display: flex;
  height: 100%;
  flex-direction: row;
  align-items: stretch;
  gap: 1rem;
  place-self: stretch;
  border-radius: 0.5rem;
  padding: 1.25rem;
  min-height:392px;
  box-shadow:0px 4px 14px rgba(0, 0, 0, 0.1);
}

.card:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(82 108 32 / var(--tw-bg-opacity));
}

.card:hover .card-date {
  --tw-bg-opacity: 1;
  background-color: rgb(212 229 179 / var(--tw-bg-opacity));
}

.card:hover .card-date {
  color: var(--blue-responsible-darken-2);
}

.card:hover .card-title, .card:hover .summary {
  color: var(--outline-white);
}

.card-content-wrapper {
  display: flex;
  width: 100%;
  flex-direction: column;
}

@media (min-width: 1280px) {

  .card-content-wrapper {
    order: 2;
  }
}

::slotted([slot='content']) {
  display: flex;
  flex-direction: column;
}

::slotted([slot='date']) {
  margin-left: 0px;
  margin-right: 0px;
  font-weight: var(--fw-bold);
  text-transform: uppercase;
  -webkit-text-decoration-line: none;
          text-decoration-line: none;
}

.card-title {
  margin-bottom: 0.5rem;
  overflow: hidden;
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  font-size: var(--fs-lg);
  line-height: var(--lh-lg);
  font-weight: var(--fw-bold);
}

.card-title, .card-content {
  width: 100%;
  color: var(--blue-responsible-main);
}

.card-summary {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}

.card-date {
  --tw-bg-opacity: 1;
  background-color: rgb(212 229 179 / var(--tw-bg-opacity));
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  font-size: var(--fs-sm);
  line-height: var(--lh-sm);
  font-weight: var(--fw-bold);
  color: var(--blue-responsible-main);
}

.tags-and-date-wrapper {
  margin-top: auto;
  padding-top: 2rem;
}

.outline-shadow {
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: 0 0 #0000, 0 0 #0000, var(--tw-shadow);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.outline-rounded-2xl {
  border-radius: 1rem;
}

.outline-bg-light-blue {
  background-color: var(--blue-responsible-lighten-5);
}

.outline-bg-blue {
  background-color: var(--blue-responsible-lighten-4);
}

.outline-bg-gray {
  background-color: var(--gray-professional-lighten-4);
}

.outline-bg-green {
  background-color: var(--green-guarantee-lighten-4);
}

.outline-bg-white {
  background-color: var(--neutral-white);
}

.outline-bg-transparent {
  background-color: var(--neutral-transparent);
}
`;